let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d5Ft0")).then(() => parcelRequire('6aOOn'));